import { EstadoComunicacaoEnum } from 'app/shared/enums';
export class ComunicacaoInfoModel {
    instante: string;
    statusComunicacao: EstadoComunicacaoEnum;
}
